import initialState from '../store/initial-state'

import {
  GET_STORAGE_HISTORY,
  GET_STORAGE_HISTORY_SUCCESS,
  GET_STORAGE_HISTORY_FAILURE,
  GET_ASSETS_LIST,
  GET_ASSETS_LIST_SUCCESS,
  GET_ASSETS_LIST_FAILURE,
  GET_FOLDER_SPACE,
  GET_FOLDER_SPACE_SUCCESS,
  GET_FOLDER_SPACE_FAILURE
} from '../constants/storage-types'

export default (state = initialState.storage, action) => {
  switch (action.type) {
    //HISTORY REDUCER
    case GET_STORAGE_HISTORY:
      return {
        ...state,
        loadingHistory: true,
        errorHistory: false,
      }
    case GET_STORAGE_HISTORY_SUCCESS:
      return {
        ...state,
        loadingHistory: false,
        errorHistory: false,
        history: action.payload.history
      }
    case GET_STORAGE_HISTORY_FAILURE:
      return {
        ...state,
        loadingHistory: false,
        errorHistory: true,
        history: [],
      }
    //ASSETS QUANTITY REDUCER
    case GET_ASSETS_LIST:
      return {
        ...state,
        loadingAssetsList: true,
        errorAssetsList: false,
      }
    case GET_ASSETS_LIST_SUCCESS:
      return {
        ...state,
        loadingAssetsList: false,
        errorAssetsList: false,
        assetsList: action.payload.assetList,
        totalAssets: action.payload.totalAssets
      }
    case GET_ASSETS_LIST_FAILURE:
      return {
        ...state,
        loadingAssetsList: false,
        errorAssetsList: true,
        assetsList: [],
        totalAssets: 0
      }
    //FOLDER SPACE REDUCER
    case GET_FOLDER_SPACE:
      return {
        ...state,
        loadingFolderSpace: true,
        errorFolderSpace: false,
      }
    case GET_FOLDER_SPACE_SUCCESS:
      return {
        ...state,
        loadingFolderSpace: false,
        errorFolderSpace: false,
        folderSpace: action.payload.folderSpace,
        folderSpaceInBytes: action.payload.folderSpaceInBytes
      }
    case GET_FOLDER_SPACE_FAILURE:
      return {
        ...state,
        loadingFolderSpace: false,
        errorFolderSpace: true,
        folderSpace: 0,
        folderSpaceInBytes: 0
      }
    default: return { ...state }
  }
}
